import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import { withTranslation } from 'react-i18next';

import * as userStorageService from 'services/user-storage-service';
import { openIntercom } from '../globals-service';

class InfoBox extends Component {
    static defaultProps = {
        contactUsEnabled: true
    }

    state = {
        visible: userStorageService.get(`infoBoxClosed_${this.props.id}`) ? false : true
    }

    handleAskUsClick = event => {
        event.preventDefault();

        openIntercom();
    }

    handleClose = () => {
        this.setState({
            visible: false
        })

        if (this.props.saveState) {
            userStorageService.set(`infoBoxClosed_${this.props.id}`, true);
        }
    }

    render() {
        userStorageService.set(`infoBoxClosed_${this.props.id}`, false);
        if (!this.state.visible) {
            return null;
        }

        const { t, content } = this.props;

        return (
            <div className="info-box">
                <button className="btn btn-small btn-square box-close" onClick={this.handleClose}>
                    <i className="ion ion-close-round" />
                </button>

                {
                    content.map((section, index) => 
                        <div className="box-section" key={index}>
                            {
                                section.title ? (
                                    <div className="box-head">
                                        {section.title}
                                    </div>
                                ) : null
                            }

                            <div className="box-body">
                                {
                                    typeof section.body === 'string' ? (
                                        <ReactMarkdown children={section.body} />
                                    ) : section.body
                                }
                            </div>
                        </div>
                    )
                }

                {
                    this.props.contactUsEnabled ? (
                        <div className="box-section" key="more">
                            <div className="box-foot">
                                {t('Have more questions')} <a href="" onClick={this.handleAskUsClick}>{t('Ask us')} <span role="img" aria-label="peace">✌️</span></a>
                            </div>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

export default withTranslation('settings')(InfoBox);
